import { post, get } from "../components/networkManager/networkHandler";

// SplashScreen

const getCountryByCDN = async() => {
  return get(`/V1/getCountryByCDN`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getData = async () => {
  return get(`/V1/getVersionV2/deviceType/9`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch data");
      }
      return response.data;
    })

    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching data",
      };
    });
};

// active plan

const getActivePlan = async(userId, publisherId) => {
  return get(`/V2/activePlan/userId/${userId}/publisher/${publisherId}`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// GET COMING SOON

const getComingSoon = async (userId, showId) => {
  return get(`/V1/getEventReminderById/${userId}/${showId}`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};


// referral

const applyReferral = async (body) => {
  return post(`/V1/applyRefral`, JSON.parse(body))
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};


const setEventReminder = async (body) => {
  return post(`/V1/setEventReminder`, JSON.parse(body))
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};



// Login Page

const userLoginSignup = async (body) => {
  return post(`/V2/userLoginSignup`, JSON.parse(body))
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Logout Apis

const logoutDevice = async (body, headers) => {
  return post(`/V2/logout-device`, JSON.parse(body), headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const logoutUser = async () => {
  return post(`/V1/logout`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
       console.log("Logout....");
      localStorage.removeItem("JWTToken");
      localStorage.removeItem("userInfo");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// QR related API

const generateQrToken = async() => {
  return get(`/V2/generateQrToken`)
    .then((response) => {
      console.log("response222", response);
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const validateQrToken = async (body) => {
  return post(`/V2/validateQrToken`, JSON.parse(body))
    .then((response) => {
      console.log("response111", response);
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Profile Page
// get user profile

const getUserProfile = async (userId) => {
  return get(
    `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch user profile");
      }
      return response?.data;
    })
    .catch((error) => {
      console.error("Error in getUserProfile:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching user profile",
      };
    });
};

// update user profile

const updateUserProfile = async (data) => {
  return post("/V1/updateUserProfile", data)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to update user profile");
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in updateUserProfile:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while updating user profile",
      };
    });
};

// get Master Hit

const getMasterHit = async() => {
  return get("/V2/getMasterHit")
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getMasterHitV2 = async (headers) => {
  return get("/V1/getMasterHitV2", headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Home content CategoryPage

const getHomeContent = async (id) => {
  return get(`/V1/getHomeContent?category_id=${id}`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get recomendation feed - HomePage
const getRecomendationFeed = async (selectedTabId, userId, headers) => {
  return get(
    `/V1/getHomeRecomendation/tag/${selectedTabId}/page/1/platform/0/userId/${userId}`,
    headers
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch recomendation feed"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getRecomendationFeed:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching recomendation feed",
      };
    });
};

// get recomendation for you - HomePage
const getRecomendationForYou = async (userId, headers) => {
  return get(`/V1/getRecomendationForYou/platform/0/userId/${userId}`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch recomendation feed"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getRecomendationFeed:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching recomendation feed",
      };
    });
};

// get grid response - HomePage

const getGridResponse = async (flag, selectedTabId, headers) => {
  return get(
    `/V1/getHomeSection/0?publisher_id=0&event=${flag}&tag=${selectedTabId}`,
    headers
  )
    .then((response) => {
      console.log(
        `/V1/getHomeSection/0?publisher_id=0&event=${flag}&tag=${selectedTabId}`,
        "here"
      );
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch recomendation feed"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getRecomendationFeed:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching recomendation feed",
      };
    });
};

// get grid response - Animated Grid

const getGridResponseAnimatedGrid = async(selectedTabId, headers) => {
  return get(`/V1/getHomeSection/0?publisher_id=${selectedTabId}`, headers)
    .then((response) => {
      console.log(`/V1/getHomeSection/0?publisher_id=${selectedTabId}`, "here");
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch recomendation feed"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getRecomendationFeed:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching recomendation feed",
      };
    });
};

const getReferalResponse = async(userId) => {
  return get(
    `/V1/getUserRefral/userId/${userId}`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch continue watching"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getContinueWatching:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching continue watching",
      };
    });
};

const getRentalStatusByIds = async (contentIds,userId) => {
  return get(
    `/V1/retrieveRentalStatusByContentIds/contentIds/${contentIds}/userId/${userId}`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch continue watching"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getContinueWatching:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching continue watching",
      };
    });
};

// get continue watching - HomePage
const getContinueResponse = async (userId, headers) => {
  return get(
    `/V1/getContinueWatching/lastupdated/0000000000/platform/0/userId/${userId}`,
    headers
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(
          response.message || "Failed to fetch continue watching"
        );
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getContinueWatching:", error.message);
      return {
        success: false,
        message:
          error.message || "Unexpected error while fetching continue watching",
      };
    });
};

// get app in app - HomePage

const getAppInApp = async(headers) => {
  return get(`/V1/getPublisherByPlaylist`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get sponsor video - HomePage

const getSponsorVideo = async(headers) => {
  return get(`/V1/getSponsorVideo/0?publisher_id=0&event=false&tag=0`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get /V1/getHomeSection?publisher_id=${selectedItem.id}

const getHomeSectionAppinApp = async(id) => {
  return get(`/V1/getHomeSection?publisher_id=${id}`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getplaylistVideo = async(playlistId, currentPage) => {
  return get(
    `/V1/getplaylistVideo/playlist/${playlistId}/platform/0/page/${currentPage}`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get Live Section - HomePage

const getLiveSection = async (country, headers) => {
  return get(`/V1/getLiveSection/0/0/0/${country}/1`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Search Page

// get search recommendations
const getSearchRecommendations = async (page, headers) => {
  return get(`/V1/getSearchRecommendations/${page}`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get search content

const getSearchContent = async (page, val, headers) => {
  return get(`/V1/getSearchContent/search/${val}/page/${page}`, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// WatchList Page

// get watchlist

// const getWatchList = async (userId, page, headers) => {
//   return get(
//     `/V1/getWatchList/lastupdated/0000000000/page/${page}/userId/${userId}`,
//     headers
//   )
//     .then((response) => {
//       if (!response.success) {
//         throw new Error(response.message || "Failed to fetch master hit");
//       }
//       console.log(response, "firstResponse");
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error in getMasterHit:", error.message);
//       return {
//         success: false,
//         message: error.message || "Unexpected error while fetching master hit",
//       };
//     });
// };

// Add/Remove Watchlist item /V1/watchList

const getWatchList = async (userId, page, headers) => {
  const ts = Date.now();
  return get(
    `/V1/getWatchList/lastupdated/0000000000/page/${page}/userId/${userId}?_=${ts}`,
    headers
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const addRemoveWatchlist = async(postParams, headers) => {
  return post(`/V1/watchList`, postParams, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Like Dislike

const addLikeDisLike = async(postParams, headers) => {
  return post(`/V1/rating`, postParams, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log("firstResponse", response );
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// addRemove favorite
const addRemoveFavorite = async(postParams, headers) => {
  return post(`/V1/favourites`, postParams, headers)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Live Screen

const getLiveChannelsV2 = async(selectedTabId, tabId = 1) => {
  return get(
    `/V1/getLiveChannelsV2/0/${tabId}/${selectedTabId}`,
    false
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getLiveChannelDetails = async(id, headers) => {
  // https://sbapi.wavespb.com/api/v1/getLiveChannelDetailsV2/id/10608/platform/1
  // v2/getLiveChannelDetails/id/0/platform/0?display=false
  // return get(`/V2/getLiveChannelDetails/id/${id}/platform/0?display=${is_subscribe}`)
  // return get(`/V1/getLiveChannelDetails/${id}/0`, headers)
  return get(`/V1/getLiveChannelDetailsV2/id/${id}/platform/0`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getFavourites = async(userId) => {
  return get(
    `/V1/getFavourites/lastupdated/0000000000/page/1/type/0/platform/0/userId/${userId}`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// /V1/getRatings/lastupdated/0000000000/page/1/userId/${userId}

// const getRatings = async(userId, page, headers) => {
//   return get(
//     `/V1/getRatings/lastupdated/0000000000/page/${page}/userId/${userId}`,
//     headers
//   )
//     .then((response) => {
//       if (!response.success) {
//         throw new Error(response.message || "Failed to fetch master hit");
//       }
//       console.log(response, "firstResponse");
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error in getMasterHit:", error.message);
//       return {
//         success: false,
//         message: error.message || "Unexpected error while fetching master hit",
//       };
//     });
// };

const getRatings = async(userId, page, headers) => {
  const ts = Date.now();
  return get(
    `/V1/getRatings/lastupdated/0000000000/page/${page}/userId/${userId}?_=${ts}`,
    headers
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};
const createDrmLicense = async(body) => {
  return post(`/V1/createDrmLicense`, body, false)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// /V1/createDrmLicenseV2?display=${Is_subscribe == 0 ? "false" : "true"}

const createDrmLicenseV2 = async(isSubscribe, body) => {
  console.log("CheckOutput", isSubscribe);
  return post(`/V1/createDrmLicenseV2?display=${isSubscribe}`, body)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// Continue Watching

// /V1/continueWatching

const addContinueWatching = async (body,headers) => {
  return post(
    `/V2/continueWatching`,
  body,
  headers
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

const getContinueWatching = async () => {
  return get(`/V1/getContinueWatching/lastupdated/0000000000`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// get Video Url

const getVideoUrl = async (videoId, userId) => {
  return get(`/V1/getVideoUrl/${videoId}/userId/${userId}?display=false`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

//

const getContentDetails = async (id, platform) => {
  return get(`/V1/getContentDetails/${id}/${platform}`)
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// /V1/getVideoUrlV2/${videoID}/userId/${userId}?display=${Is_subscribe == 0 ? "false" : "true"}

const getVideoUrlV2 = async (videoID, userId, Is_subscribe) => {
  return get(
    `/V1/getVideoUrlV2/${videoID}/userId/${userId}?display=${
      Is_subscribe == 0 ? "false" : "true"
    }`
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

// /V1/getContentPlaybackInfo?publisher_id=${data?.owned_by}

// const getContentPlaybackInfo = (data) => {
//   return get(
//     `/V1/getContentPlaybackInfo?publisher_id=${data}`,
//   )
//     .then((response) => {
//       if (!response.success) {
//         throw new Error(response.message || "Failed to fetch master hit");
//       }
//       console.log(response, "firstResponse");
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error in getMasterHit:", error.message);
//       return {
//         success: false,
//         message: error.message || "Unexpected error while fetching master hit",
//       };
//     });
// }; 

const getContentPlaybackInfo = async (data, body, headers) => {
  return post(
    `/V1/getContentPlaybackInfo?publisher_id=${data}`,
    body,
    JSON.stringify(headers),
  )
    .then((response) => {
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch master hit");
      }
      console.log(response, "firstResponse");
      return response.data;
    })
    .catch((error) => {
      console.error("Error in getMasterHit:", error.message);
      return {
        success: false,
        message: error.message || "Unexpected error while fetching master hit",
      };
    });
};

export {
  getData,
  getCountryByCDN,
  userLoginSignup,
  logoutDevice,
  logoutUser,
  generateQrToken,
  validateQrToken,
  updateUserProfile,
  getUserProfile,
  getMasterHit,
  getMasterHitV2,
  getHomeContent,
  getRecomendationFeed,
  getRecomendationForYou,
  getGridResponse,
  getGridResponseAnimatedGrid,
  getContinueResponse,
  getAppInApp,
  getSponsorVideo,
  getLiveSection,
  getSearchRecommendations,
  getSearchContent,
  getWatchList,
  getplaylistVideo,
  getLiveChannelsV2,
  getLiveChannelDetails,
  getFavourites,
  createDrmLicense,
  createDrmLicenseV2,
  getRatings,
  addRemoveWatchlist,
  addRemoveFavorite,
  addLikeDisLike,
  applyReferral,
  getHomeSectionAppinApp,
  getVideoUrl,
  getContentDetails,
  getVideoUrlV2,
  getContentPlaybackInfo,
  addContinueWatching,
  getContinueWatching,
  getActivePlan,
  getReferalResponse,
  getRentalStatusByIds,
  setEventReminder,
  getComingSoon,
};